import type { initialAvatarStateType } from "src/reducks/AvatarStore/types";

export const initialAvatarState: initialAvatarStateType = {
  initSelectedItems: [],
  initSelectedStageItems: [],
  prevSelectedItems: [],
  prevSelectedStageItems: [],
  selectedItems: [],
  selectedPoints: 0,
  selectedStageItems: [],
};
